import { Noop } from '../types/utilities'

/**
 * 在 react 的下一个渲染队列中执行回调函数
 *
 * @param fn 回调函数
 */
export const nextTick = (fn: Noop) => setTimeout(fn, 0)

/**
 * 睡眠等待
 *
 * @param wait 等待时间
 */
export const sleep = async (wait: number) => {
  return new Promise(resolve => {
    setTimeout(resolve, wait)
  })
}
